import { render, staticRenderFns } from "./payment-extras.vue?vue&type=template&id=84ba6230&scoped=true"
import script from "./payment-extras.vue?vue&type=script&lang=js"
export * from "./payment-extras.vue?vue&type=script&lang=js"
import style0 from "./payment-extras.vue?vue&type=style&index=0&id=84ba6230&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba6230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84ba6230')) {
      api.createRecord('84ba6230', component.options)
    } else {
      api.reload('84ba6230', component.options)
    }
    module.hot.accept("./payment-extras.vue?vue&type=template&id=84ba6230&scoped=true", function () {
      api.rerender('84ba6230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/list/payment-extras.vue"
export default component.exports